
<Modal :mayCancel="true" v-on:done="onDone" v-on:cancel="onDone">
  <h2>Share</h2>
  <p>Each link provides different capabilities.</p>
  <form
    class="Share_Form PForm"
    v-on:click.stop
    v-for="(shareLink, index) in shareLinks"
    :key="shareLink.accessLevel"
  >
    <p>
      <strong>{{ getTitle(shareLink.accessLevel) }}:</strong>
      {{ getDescription(shareLink.accessLevel) }}
    </p>
    <div class="InputAndCopy">
      <input
        ref="textInput"
        class="Share_Link"
        type="text"
        :value="shareLink.url"
        v-on:click="selectInput(index)"
      />
      <CopyButton :text="shareLink.url"></CopyButton>
    </div>
  </form>
  <div class="ButtonRow_Right">
    <button class="WBMBigButton" v-on:click="onDone">Done</button>
  </div>
</Modal>
